/* @flow */

import React from "react";
import { useData } from "crustate/react";
import { useClient, StoreInfoContext } from "entrypoint/shared";

import { QuoteData, CmsData } from "data";
import { Checkout } from "@crossroads/shop-views";
import CmsPageView from "components/CmsPageView";
import { subscribeToNewsletter } from "queries";
import { useAnalytics } from "context/analytics";
import useFormat from "helpers/use-format";
import { altapay } from "config";

const Overview = (): React$Node => {
  const quote = useData(QuoteData);
  const cmsData = useData(CmsData);
  const { formatPrice } = useFormat();
  const analytics = useAnalytics();

  const CmsPage = cmsData.state === "LOADED" ? <CmsPageView cmsPage={cmsData.data} showBreadcrumbs={false} /> : null;

  if (!quote.data) {
    return null;
  }

  return (
    <Checkout
      analytics={{ context: analytics }}
      quote={quote}
      formatPrice={formatPrice}
      useClient={useClient}
      subscribeToNewsletter={subscribeToNewsletter}
      StoreInfoContext={StoreInfoContext}
      scriptURL={altapay.src}
      agreement={CmsPage}
    />
  );
};

export default Overview;
